import { Controller } from "@hotwired/stimulus"

// Adds and removes nested rows (e.g. song files) from a <template>.
// New rows are dropped from the DOM; saved rows are flagged with _destroy.
export default class extends Controller {
  static targets = ["template", "list"]

  connect() {
    this.form = this.element.closest("form")
    this.renumber = this.renumber.bind(this)
    this.form?.addEventListener("submit", this.renumber)
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.renumber)
  }

  moveUp(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-nested-row]")
    let previous = row.previousElementSibling
    while (previous && previous.hidden) previous = previous.previousElementSibling
    if (previous) previous.before(row)
  }

  moveDown(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-nested-row]")
    let next = row.nextElementSibling
    while (next && next.hidden) next = next.nextElementSibling
    if (next) next.after(row)
  }

  // Order on screen = order saved
  renumber() {
    this.listTarget.querySelectorAll("[data-nested-row]").forEach((row, index) => {
      const input = row.querySelector("input[data-position]")
      if (input) input.value = index
    })
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, `${Date.now()}`)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    window.lucide?.createIcons()
    const added = this.listTarget.lastElementChild
    const fileInput = added?.querySelector("input[type=file]")
    if (fileInput) fileInput.click()
    else added?.querySelector("input:not([type=hidden]), select")?.focus()
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-nested-row]")
    if (row.dataset.newRecord === "true") {
      row.remove()
    } else {
      row.querySelector("input[name*='[_destroy]']").value = "1"
      row.hidden = true
    }
  }
}
